import feathers from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import io from 'socket.io-client'
import auth from '@feathersjs/authentication-client'

// Create a socket.io v4 client
const socket = io('https://api.getboarded.tech', {
  transports: ['websocket'],
})

// Create a Feathers client and configure it to use socket.io
const app = feathers().configure(socketio(socket, { timeout: 20000 }));


export {app,socket};